
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In einzelnen Kantonen spielten sich in Heimen regelrechte Tragödien ab: Die
bisher zwölf Todesfälle im Glarnerland wegen der Corona-Pandemie konzentrieren
sich weitgehend auf das Alterszentrum Bühli in Ennenda. Auch im Kanton Schwyz
entfällt fast die Hälfte der Todesfälle, die mit dem Coronavirus in Verbindung
stehen, auf ein einziges Altersheim. Im Zentrum Bon-Séjour in Versoix GE sind
seit Beginn des Jahres 26 der 92 Bewohner gestorben - normal sterben im gleichen
Zeitraum 5 oder 6 Personen. Nicht alle Toten wurden auf Corona getestet. Im
Altersheim Haut-de-Cry in Vétroz VS sind mindestens 15 der 100 Bewohner am
Coronavirus gestorben.`}</p>
    <p>{`Was auffällt: Es gibt keine grossen Unterschiede zwischen der lateinischen
Schweiz und der Deutschschweiz. Sowohl im Tessin, wie in Zürich und Bern als
auch in der Waadt oder in Genf fällt ein grosser Teil der Sterbefälle auf
Alterseinrichtungen.`}</p>
    <p>{`In Schweden wurde der Schutz der Alten zu einer zentralen Säule des schwedischen
Kurses erklärt.
`}<a parentName="p" {...{
        "href": "https://www.tagesanzeiger.ch/schweden-wollte-die-alten-schuetzen-und-scheiterte-705468242240"
      }}>{`Statistiken zeigen aber`}</a>{`,
dass auch dort weit mehr als die Hälfte der Todesfälle in Alten- und
Pflegeheimen gezählt wurden. Dieser Teil der Strategie war «katastrophal
gescheitert», wie die Zeitung «Aftonbladet» schrieb. Schweden habe «die Alten
geopfert», titelte der staatliche finnische Sender YLE. Schwedens
Behördenvertreter gestehen mittlerweile in diesem Punkt ihr Scheitern ein. Die
Regierung untersucht, was schiefgelaufen ist.`}</p>
    <p>{`Auch in Grossbritannien, wo 40 Prozent aller Todesfälle in Alterszentren
aufgetreten sind,
`}<a parentName="p" {...{
        "href": "https://www.sueddeutsche.de/politik/corona-in-grossbritannien-absolut-grauenhaft-1.4907681"
      }}>{`wächst der Druck`}</a>{`
auf Premier Boris Johnson. Ein Streit über die Krise in den Alten- und
Pflegeheimen ist entbrannt. In einem Rundfunkinterview räumte der Minister für
Wohnungsbau und Kommunen, Robert Jenrick, ein, die Situation in Altenheimen sei
«absolut grauenhaft». Jüngsten Studien zufolge könnten in britischen
Pflegeeinrichtungen bisher bis zu 20’000 Menschen gestorben sein.`}</p>
    <p>{`In der Schweiz allerdings, wo anteilsmässig ähnlich viele Menschen in
Pflegeeinrichtungen gestorben sind wie in Schweden, scheint sich niemand
wirklich zu empören. Bezeichnend dafür die Bilanz der Schweizerischen
Patientenorganisation (SPO): Generell verzeichnete die Organisation bis anhin
generell nur «wenige Rückmeldungen» im Zusammenhang mit dem Coronavirus, wie
Daniel Tapernoux, Mitglied der Geschäftsführung, sagt. Und davon betrafen nur
«vereinzelte Anfragen eine Corona-Ansteckung in einer Institution».`}</p>
    <p>{`Auch die Vereinigung der Kantonsärztinnen und Kantonsärzte der Schweiz (VKS)
sieht keinen Handlungsbedarf. Deren Präsident Rudolf Hauri, eine wichtige Figur
in der Bekämpfung der Pandemie, sagt: «Es ist unangebracht, davon zu sprechen,
dass ältere Personen in der Schweiz geopfert wurden. Sobald die Faktenlage
klargemacht hatte, dass unter anderem ältere Personen besonders durch das neue
Coronavirus gefährdet sind, haben Bund und Kantone ihre Kommunikation und ihre
Massnahmen entsprechend ausgelegt.»`}</p>
    <p>{`Es liege «in der Natur der Sache», dass es in Alters- und Pflegeheimen zu
häufigen Todesfällen komme. «Zudem muss man beachten, dass nicht bei allen
gemeldeten Covid-Todesfällen dieses Virus die alleinige oder tatsächliche
Todesursache war. Viele der verstorbenen Personen in Pflegeheimen haben sich
bereits unabhängig von dieser Erkrankung in kritischen oder terminalen
Gesundheitszuständen befunden.»`}</p>
    <p>{`Dass man die Todesfälle der Betagten hierzulande mehr oder weniger hinzunehmen
scheint, ist umso erstaunlicher, wenn man bedenkt, dass in den Heimen
tatsächlich vieles nicht optimal gelaufen ist. Selbst bei Curaviva, dem
nationalen Verband der Alters- und Pflegeheime der Schweiz, räumt man jetzt
Fehler ein.`}</p>
    <p>{`Ein Problem war das fehlende Schutzmaterial, wie die Medien bereits zu Beginn
der Krise berichtet hatten. Mit zunehmender Dauer der Pandemie verschärfte sich
der Engpass sogar noch. «Es gab Mängel in der Schutzmaterialversorgung», sagt
Markus Leser, bei Curaviva Leiter des Fachbereichs Menschen im Alter. «Die
Situation war in den Heimen grundsätzlich angespannt, in Einzelfällen sogar sehr
schwierig.»`}</p>
    <p>{`Dass dies nicht nur der Fehler der Heime ist, sondern auch ein strukturelles
Problem, liegt auf der Hand: Die Heime stehen unter grossem wirtschaftlichem
Druck, und die vorsorgliche Beschaffung von Schutzmaterial ist kostspielig.`}</p>
    <p>{`Probleme bereitete den Heimen aber auch grundsätzlich die Neuartigkeit des
Coronavirus. «Dessen Gefährlichkeit zeigte sich in der zweiwöchigen
Inkubationszeit ohne oder nur mit leichten Symptomen», sagt Leser. So habe sich
das Virus anfangs unbemerkt in den Heimen ausbreiten können - zuerst über
Besucher und Bewohner sowie vor und nach dem Besuchsverbot auch über das
Personal.`}</p>
    <p>{`Die Folge: Die bestehenden Schutzkonzepte der Heime, ausgerichtet auf
Krankheiten wie die Schweinegrippe und das Norovirus, versagten - und mussten in
der Folge angepasst werden.`}</p>
    <p>{`Und da stellt sich natürlich die Frage, wie die Heime für eine mögliche zweite
Welle gerüstet sind.`}</p>
    <p>{`Andreas Stuck ist Medizin-Professor und Präsident der Schweizerischen
Fachgesellschaft für Geriatrie (SFGG). Er sagt: «Im Hinblick auf eine mögliche
zweite Welle braucht es jetzt ein nationales Schutzkonzept, das für alle Heime
gilt und klare Regeln vorgibt.» Ein solches Konzept müsse zum Beispiel
vorschreiben, «wie man mit Neueintritten umgeht, wie Patienten isoliert werden
und wer das Ganze überwacht». Stuck denkt auch an mögliche neue Rollen in den
Heimen: Spezialisten etwa, «die sich um das Viren-Management kümmern». Und
vielleicht, so sagt der oberste Geriater der Schweiz, müssten die Heime künftig
auch Schutzmaterial für Besucher bereitstellen können.`}</p>
    <p>{`Von einem nationalen Schutzkonzept ist man in der Schweiz derzeit allerdings
weit entfernt. Der Bund schreibt bloss vor, dass die Heime überhaupt ein
Schutzkonzept haben müssen - wie dieses ausgestaltet ist, kann von Kanton zu
Kanton und sogar von Ort zu Ort unterschiedlich sein.`}</p>
    <p>{`Der Heim-Verband Curaviva begrüsst den Status quo. Es gebe «keine Anzeichen»
dafür, dass es mit der bestehenden Regelung Probleme gebe, sagt Leser von
Curaviva. Die Heime seien daran, die neuen Schutzkonzepte umzusetzen, oder sie
hätten dies schon gemacht.`}</p>
    <p>{`Selbst minimale Vorgaben vom Bund lehnt Curaviva ab. Einem solchen Eingriff
zustimmen würde der Verband laut Leser erst, «falls sich der aktuelle Ansatz als
nicht zielführend erweisen sollte». Um dies zu beurteilen, sei es aber noch zu
früh. Die Kantone müssten jedoch selbst in diesem Fall die Möglichkeit haben,
«den regionalen Gegebenheiten Rechnung zu tragen». Hinzu kommt, dass der
Bundesrat aus Sicht von Curaviva ausserhalb des Notrechts gar keine Möglichkeit
hat, ein Schutzkonzept für Heime national verbindlich zu erklären.`}</p>
    <p>{`Befürworten würde Curaviva indessen die Idee des Viren-Managements, wie Leser
sagt. Allerdings sei dies gegenwärtig «illusorisch, da im Moment noch nicht
einmal klar ist, ob und wie die Institutionen ihre Covid-19-bedingten Mehrkosten
zurückerstattet erhalten».`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;